/* global $ */

import { gup } from '../helpers/params';

// BSD sourcing
const source = gup('utm_source') || gup('source');

$(document).ready(() => {
  if (source) {
    $.$body.find('.bsd-form').each(function() {
      const $form = $(this);
      if ($form.find('[name="source"]').length) {
        $form.find('[name="source"]').val(source);
      } else {
        $('<input/>', {
          type: 'hidden',
          name: 'source',
          value: source,
        }).appendTo($form);
      }
    });
  }

  // helper to replace action network input with btns
  /* eslint-disable */
  function swapBtn(form) {
    const $submit = $(form).find('input[type=submit]');
    const val = $submit.val();
    const node = `<button class="custom-submit btn" type="submit" name="commit">${val}</button>`;
    $submit.after(node);
    $submit.hide();
    $submit.addClass('-force-hide');
  }

  function wrapCheckBox(form, i) {
    const $checks = $(form).find('input[type=checkbox]');
    const check =
      '<svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" viewBox="0 0 512 512" enable-background="new 0 0 512 512" xml:space="preserve"><polygon points="428.772,55.96 196.737,288.922 83.228,174.957 0.013,258.516 196.69,456.039 511.987,139.488 "></polygon></svg>';
    if ($checks) {
      let id = 0;
      $checks.each(function() {
        const $this = $(this);
        if (!$this.hasClass('customized')) {
            $this.parent().addClass('customized custom-check');
            $this.addClass('customized');
            $this.parent().attr('for', `mobile_opt_in_checkbox_${id}_${i}`);
            $this.attr('id', `mobile_opt_in_checkbox_${id}_${i}`);
            $($this).after(`<span class="checkmark">${check}</span>`);
          id += 1;
        }
      });
    }
  }

  /**
   * Manually apply aria updates to the forms.
   * Multiple forms cause issues with dupe markup,
   * filter and process here.
   * 
   * @param {HTMLElement} form 
   * @param {int} i 
   */
  function updateAria(form, i) {
    // Wrap in list.
    const col = form
      .querySelector('#form_col1');
    const children = Array.prototype.slice.call(col.children);
    if (children.length !== 1) {
      const list = document.createElement('ul');
      children.forEach(function(child) {
        // ensure li wrap.
        if (child.tagName !== 'LI') {
          const li = document.createElement('li');
          li.classList.add('custom-form-list-item');
          li.appendChild(child);
          list.appendChild(li);
        } else {
          list.appendChild(child);
        }
      });
      while (col.firstChild) {
        col.removeChild(col.firstChild);
      }
      col.appendChild(list);
    }

    /**
     * use SetTimeout to trigger update, 
     * hopefully after AN has rendered.
     */
    setTimeout(() => {
      // Flags.
      const flag = form.querySelector('.iti__selected-flag');
      if (flag && !flag.getAttribute('aria-expanded')) {
        flag.setAttribute('aria-expanded', false);
        flag.removeAttribute('aria-owns');
      }   

      // Labels.
      let labels = form.querySelectorAll('label.floatlabel-label');
      labels = Array.prototype.slice.call(labels);
      labels.forEach(function(label) {
        if (label.getAttribute('for') && label.getAttribute('data-modified') !== 'true') {
          form.querySelector('#' + label.getAttribute('for')).setAttribute('id', `${label.getAttribute('for')}_${i}`);
          label.setAttribute('for', `${label.getAttribute('for')}_${i}`);
          label.setAttribute('data-modified', true);
        }
      });

      // Select 2 accessibility text.
      let s2 = form.querySelectorAll('a.select2-choice');
      s2 = Array.prototype.slice.call(s2);
      s2.forEach(function(s) {
        const t = document.createElement('span');
        t.innerHTML = 'Select an option';
        t.classList.add('screen-reader-text');
        s.appendChild(t);
      });
    }, 10);
  }

  /**
   * Setup our Mutation Observer to watch for form markup changes.
   */
  function actionNetworkChangeHandler() {
    const forms = document.getElementsByClassName('action-form');
    if (forms.length > 0) {
      for (let i = 0; i < forms.length; i += 1) {
        function observeChange() {
          const targetNode = forms[i];
          const observerOptions = {
            childList: true,
            subtree: true,
          };
          function customForm() {
            swapBtn(forms[i]);
            wrapCheckBox(forms[i], i);
            updateAria(forms[i], i);
            crmObserver.disconnect();
          }
          const crmObserver = new MutationObserver(customForm);
          crmObserver.observe(targetNode, observerOptions);
        }
        observeChange();
      }
    }
  }
  actionNetworkChangeHandler();
  /* eslint-disable */
});
